import type { VisibilityState } from "@tanstack/react-table";
import { useTableViewOptions } from "@/components/custom/table/hooks/use-table-view-options";
import { serverColumns } from "./table/columns";

type ServersViewOptionsProps = {
  onVisibilityChange?: (
    visibility: VisibilityState,
    setter: (
      value: VisibilityState | ((val: VisibilityState) => VisibilityState)
    ) => void
  ) => void;
};

type ServersViewOptionsReturn = {
  columnVisibility: VisibilityState;
  setColumnVisibility: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
  component: React.ReactElement;
};

export const useServersViewOptions = ({
  onVisibilityChange,
}: ServersViewOptionsProps = {}): ServersViewOptionsReturn => {
  // Get column definitions
  const columns = serverColumns;

  // Use the generic table view options hook
  return useTableViewOptions({
    columns,
    storageKey: "servers-table-column-visibility",
    onVisibilityChange,
    label: "Columns",
    className: "h-9 px-3 gap-2",
  });
};
